// ForwardLoginForm.js

import React, {useState} from 'react';
import { FormControl, FormLabel, Input, Button, Link, useColorModeValue, Text } from "@chakra-ui/react";
import { Link as ReachLink } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const ForwardLoginForm = ({arrival_url=false, mode="hero"}) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const { loginWithPassword } = useAuth();

    let bgColor = useColorModeValue('gray.100','gray.700');
    let textColor = useColorModeValue('black','white');
    let bdColor = useColorModeValue('gray.200','gray.600');
    if (mode === 'hero') {
        bgColor = 'gray.200';
        textColor = 'black';
        bdColor = 'gray.200';
    }

    const isEmailValid = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    };

    const hasPassword = (password) => {
        return password.length > 0;
    };

    const handleLoginForward = async (event) => {
        event.preventDefault()
        loginWithPassword(email, password, 'forward', arrival_url);
      }

    const isButtonDisabled = !isEmailValid(email) || !hasPassword(password);

    return (
        <form onSubmit={handleLoginForward}>
            <FormControl id="email" my={2}>
                <FormLabel>Email address</FormLabel>
                <Input type="email"
                fontWeight="bold" 
                size="lg" 
                textAlign="center" 
                variant="outline" 
                borderRadius={0} 
                backgroundColor={bgColor}
                boxShadow="rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;"
                color={textColor}
                placeholder="Enter E-mail" 
                _placeholder={{opacity:0.9,color:'inherit'}} 
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </FormControl>
            <FormControl id="password" my={2}>
                <FormLabel >Password</FormLabel>
                <Input type="password"
                fontWeight="bold" 
                size="lg" 
                textAlign="center" 
                variant="outline" 
                borderRadius={0} 
                backgroundColor={bgColor}
                boxShadow="rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;"
                color={textColor}
                placeholder="Password" 
                _placeholder={{opacity:0.9,color:'inherit'}} 
                 value={password} onChange={(e) => setPassword(e.target.value)} />
            </FormControl>
            <Text textAlign="left" fontSize="sm" fontStyle="oblique">Forgot your password? Just go sign up and enter your e-mail, we'll send you a link to log in!</Text>
            <Button my={4} width="100%" colorScheme="green" type="submit" isDisabled={isButtonDisabled}>
                Login
            </Button>
        </form>
    );
};

export default ForwardLoginForm;
